import 'css-chunk:src/accordion/accordion.module.scss';export default {
  "heading-xxl": "accordion-module__heading-xxl___i8m47",
  "wrapper": "accordion-module__wrapper___TT1lW",
  "heading-xl": "accordion-module__heading-xl___vnvvM",
  "heading-lg": "accordion-module__heading-lg___hpGpQ",
  "heading-md": "accordion-module__heading-md___5IFbg",
  "heading-sm": "accordion-module__heading-sm___RoKyu",
  "heading-xs": "accordion-module__heading-xs___ZC3YB",
  "body-one": "accordion-module__body-one___ZtF7L",
  "body-two": "accordion-module__body-two___vqPZL",
  "body-three": "accordion-module__body-three___mvlfq",
  "body-four": "accordion-module__body-four___IeFTN",
  "overline-one": "accordion-module__overline-one___gxoFY",
  "overline-two": "accordion-module__overline-two___qGJ7f",
  "overline-three": "accordion-module__overline-three___1-fxH",
  "strong": "accordion-module__strong___Rlhh4",
  "em": "accordion-module__em___-Eomb",
  "figcaption": "accordion-module__figcaption___cOWca",
  "no-margin": "accordion-module__no-margin___XD5DK",
  "accordion": "accordion-module__accordion___J7Hbu"
};